var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaloaUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 21.7L17 17.3C16.8 17.1 16.6 17 16.3 17H7.7C7.4 17 7.2 17.1 7 17.3L2.4 21.7L1 20.3L5.6 15.9C6.1 15.3 6.9 15 7.7 15H16.3C17.1 15 17.8 15.3 18.4 15.9L23 20.3L21.6 21.7Z",
    fill: "#71847B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C8.9 13 6.3 10.5 6.3 7.30001C6.3 4.10001 8.9 1.60001 12 1.60001C15.1 1.60001 17.7 4.20001 17.7 7.30001C17.7 10.4 15.1 13 12 13ZM12 3.60001C10 3.60001 8.3 5.30001 8.3 7.30001C8.3 9.30001 10 11 12 11C14 11 15.7 9.30001 15.7 7.30001C15.7 5.30001 14 3.60001 12 3.60001Z",
    fill: "#71847B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaloaUser);
export default __webpack_public_path__ + "static/media/baloa-user.f6b38927b9273f68da33accfc3079b01.svg";
export { ForwardRef as ReactComponent };